import React from 'react';
import './PartnersPage.css';

import { Heading, PageTitle } from '../../../components';
import { partners } from '../../../constants';



const PartnersPage = () => {
  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Partners'} page={'Partners'} />

      <section className='partners'>

        {/* Section heading */}
        <Heading title={'Our Partners'} span={'Securing Trust'} />

        <div className='box-container'>

          {/* Loop through the partners array to display each partner's logo */}
          {partners.map((partner, index) => {
              return (
                <div className='partner-item' key={index}>
                  {/* Render the partner logo */}
                  <img src={partner} alt='Partner Logo' />
                </div>
              );
            })
          }

        </div>

      </section>

    </>
  );
}

export default PartnersPage;